export const TYPES = {
    ADD_TO_DESPATCH: "ADD_TO_DESPATCH",
    REMOVE_TO_DESPATCH: "REMOVE_TO_DESPATCH",
    CLEAR_DESPATCH: "CLEAR_DESPATCH"
}